import { render, staticRenderFns } from "./PassBookList.vue?vue&type=template&id=3c8a80d0"
import script from "./PassBookList.vue?vue&type=script&lang=js"
export * from "./PassBookList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports